import { render } from "./WindowsApplication.vue?vue&type=template&id=25cebbd3"
import script from "./WindowsApplication.vue?vue&type=script&lang=js"
export * from "./WindowsApplication.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__